import { Input, Select } from "antd";
import { useEffect,useState } from "react";

const { Search } = Input;

interface Props {
    value: string;
    onChange: (value: string) => void;
    onSearch: () => void;
}

export default function SearchBox({
    value,
    onChange,
    onSearch,
}: Props) {

    const [type, setType] = useState("order");

    const [localValue, setLocalValue] =
    useState(value);

useEffect(() => {
    const timeout = setTimeout(() => {
        onChange(localValue);
    }, 500);

    return () =>
        clearTimeout(timeout);

}, [localValue]);

    const options = [
        { label: "Mã đơn hàng", value: "order" },
        { label: "Tên khách hàng", value: "name" },
        { label: "Số điện thoại", value: "phone" },
        { label: "Mã khách hàng", value: "customerCode" },
        { label: "Khác", value: "other" },
    ];

    return (
        <Search
            value={localValue}
            onChange={(e) =>
                setLocalValue(e.target.value)
            }

            onSearch={onSearch}

            placeholder="Mã ĐH/KM hoặc tên/số ĐT KH"

            enterButton="Tìm kiếm"

            className="w-[500px]"

            addonBefore={
                <Select
                    value={type}
                    onChange={setType}
                    options={options}
                    style={{ width: 180 }}
                />
            }
        />
    );
}